import { render, staticRenderFns } from "./MyWorkFromHome.vue?vue&type=template&id=21d0f603&"
import script from "./MyWorkFromHome.vue?vue&type=script&lang=js&"
export * from "./MyWorkFromHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports